import { DOMcreateElement } from '../typescript/TSXDomParse';
import FooterColumn from './FooterColumn';
import FooterColumnMobile from './FooterColumnMobile';
export default function Footer(data, isMobile) {
    if (isMobile === void 0) { isMobile = false; }
    /*
     * For mobile, group some lists together for two-column layout
     *
     */
    var dataFormattedForMobile = function (data) {
        // List of indexes where a new column will start
        var columnStarts = [0, 1, 4];
        var output = [];
        var index = 0;
        var column = []; // Temp var to store the links of current column
        for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
            var node = data_1[_i];
            // Indexes are removed from columnStarts as they are consumed,
            // first index will always be the current working index
            if (columnStarts[0] === index) {
                // Start a new column
                // - add contents to output variable
                if (column.length)
                    output.push(column);
                // Remove first element from columnStarts,
                // it is used
                columnStarts.shift();
                column = [node];
            }
            else {
                // Continue addding to current working column
                column.push(node);
            }
            // Keep track of index
            index += 1;
        }
        // Since columns are only added to output when a new column is
        // started, the final column with be left on its own. Add it here
        if (column.length)
            output.push(column);
        return output;
    };
    var formattedData = dataFormattedForMobile(data);
    return (DOMcreateElement("div", { className: "footer-block link-wrapper " + (isMobile ? 'mobile-only' : 'desktop-only') }, isMobile
        ? formattedData === null || formattedData === void 0 ? void 0 : formattedData.map(function (column) { return (DOMcreateElement(FooterColumnMobile, { data: column })); })
        : data.map(function (column) {
            var _a;
            return (DOMcreateElement(FooterColumn, { links: (_a = column.fields) === null || _a === void 0 ? void 0 : _a.components }));
        })));
}
